export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ea8170987491c5df74e2d787dafbaa91.jpg')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center text-white">
        <div className="flex flex-col items-center">
          {/* Professional Image */}
          <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white/90 shadow-2xl mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/7ed708d0-0e46-4404-b490-9c89f3f516ab.png" 
              alt="Augustine Anyimadu-Ahenkae"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Eyebrow Label */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/40 rounded-full px-5 py-2 mb-6 text-emerald-300 text-sm font-semibold tracking-widest uppercase">
            <i className="ri-star-fill text-amber-400"></i>
            Phenomenal · Legendary · Proven
          </div>
          
          {/* Title */}
          <h1 className="text-5xl md:text-7xl font-bold mb-4 leading-tight">
            Master <span className="text-amber-400 drop-shadow-lg">MATHEMATICS</span><br />at Every Level
          </h1>

          {/* Subtitle */}
          <p className="text-2xl md:text-3xl font-semibold mb-8 text-white/90">
            with Mr. Augustine Anyimadu-Ahenkae
          </p>
          
          {/* Credentials */}
          <div className="flex flex-wrap justify-center gap-5 mb-8 text-base md:text-lg">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-5 py-2 border border-white/20">
              <i className="ri-user-star-line text-2xl text-amber-400"></i>
              <span className="font-semibold">Former NYC Public High School Math Teacher</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-5 py-2 border border-white/20">
              <i className="ri-trophy-line text-2xl text-amber-400"></i>
              <span className="font-semibold">Education Chancellor Honored &amp; Publicly Praised</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-5 py-2 border border-white/20">
              <i className="ri-medal-line text-2xl text-amber-400"></i>
              <span className="font-semibold">25+ Years Making Every Student Succeed</span>
            </div>
          </div>
          
          {/* Description */}
          <p className="text-xl md:text-2xl mb-12 max-w-4xl leading-relaxed font-light text-white/90">
            Comprehensive Math Solutions for K–12, Standardized Tests, and Beyond.<br />
            Step-by-step explanations that make <em>every</em> level look easy.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-wrap justify-center gap-6">
            <button 
              onClick={() => {
                const element = document.getElementById('membership-tiers');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-5 bg-emerald-600 hover:bg-emerald-700 text-white text-lg font-semibold rounded-lg shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Explore Membership Options
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('testimonials');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-5 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white text-lg font-semibold rounded-lg border-2 border-white/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              View Success Stories
            </button>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 mt-16 max-w-3xl w-full">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-emerald-400 mb-2">5,000+</div>
              <div className="text-base md:text-lg font-light">Students Taught</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-emerald-400 mb-2">95%</div>
              <div className="text-base md:text-lg font-light">Improvement Rate</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-emerald-400 mb-2">4.9/5</div>
              <div className="text-base md:text-lg font-light">Student Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
